var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramShopping40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features-and-Benefits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Note",
    transform: "translate(7.000000, 12.500000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shopping",
    transform: "translate(5.500000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: 64,
    fillOpacity: 0.25,
    fill: "#88BCF8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "64pt",
    opacity: 0.15,
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.437500, 2.265625)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22",
    stroke: "#4F4C4D",
    strokeWidth: 0.75,
    fill: "#FFFFFF",
    x: 0,
    y: 5.4375,
    width: 18.125,
    height: 17.671875
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-22-Copy",
    stroke: "#4F4C4D",
    strokeWidth: 0.75,
    fill: "#FFCC00",
    x: 0,
    y: 19.484375,
    width: 18.125,
    height: 3.625
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#4F4D4C",
    cx: 4.3046875,
    cy: 8.3828125,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#4F4D4C",
    cx: 13.8203125,
    cy: 8.3828125,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2734375,5.4375 C14.2734375,2.43445167 11.9404213,0 9.0625,0 C6.18457869,0 3.8515625,2.43445167 3.8515625,5.4375",
    id: "Oval",
    stroke: "#4F4C4D",
    strokeWidth: 0.75
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramShopping40);
export default __webpack_public_path__ + "static/media/pictogramShopping40.964c953b3fd35371dcf977f343c9a831.svg";
export { ForwardRef as ReactComponent };